module.exports = __webpack_public_path__ + "static/img/label04.27aa2afa.png";